import { createTheme } from "@mui/material"
let theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            lgp: 1248,
            xl: 1600,
            xlp: 1648,
            xxl: 1920,
        },
    },
    palette: {
        primary: {
            main: '#13234A',
            light: '#124A9D',
        },
        black: {
            400: '#333333',
            500: '#1f2533',
        },
        background: {
            500: '#F0F4FF',
        },
        blue: {
            400: '#13234A',
            500: '#124A9D',
        },
        red: {
            400: '#C4251D',
            500: '#C32527',
        },
    }
})


theme = createTheme(theme, {

    typography: {
        fontFamily: "'Fira Sans',Arial,sans-serif",
        fontStyle: 'normal',
        fontWeight: 400,

        body1: {
            fontFamily: "'Fira Sans',Arial,sans-serif",
            color: theme.palette.black[500],
        },
        body2: {
            fontFamily: "'Fira Sans',Arial,sans-serif",
            color: theme.palette.blue[400],
            fontWeight: 400,
            lineHeight: '120%',
            letterSpacing: '0px',
            [theme.breakpoints.up('xs')]: {
                fontSize: '15px',
            },
            [theme.breakpoints.up('sm')]: {
                fontSize: '16px',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '18px',
            },
            [theme.breakpoints.up('lg')]: {
                fontSize: '18px',
            },
        },
        body3: {
            fontFamily: "'Fira Sans',Arial,sans-serif",
            color: theme.palette.black[400],
            fontWeight: 400,
            lineHeight: '21px',
            letterSpacing: '0px',
            [theme.breakpoints.up('xs')]: {
                fontSize: '13px',
            },
            [theme.breakpoints.up('sm')]: {
                fontSize: '14px',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '16px',
            },
            [theme.breakpoints.up('lg')]: {
                fontSize: '16px',
            },
        },
        body4: {
            fontFamily: "'Fira Sans',Arial,sans-serif",
            color: theme.palette.black[400],
            fontWeight: 400,
            lineHeight: '120%',
            letterSpacing: '0px',
            [theme.breakpoints.up('xs')]: {
                fontSize: '14px',
            },
            [theme.breakpoints.up('sm')]: {
                fontSize: '16px',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '18px',
            },
            [theme.breakpoints.up('lg')]: {
                fontSize: '18px',
            },
        },
        h1: {
            fontFamily: "'Fira Sans',Arial,sans-serif",
            fontWeight: 700,
            lineHeight: '120%',
            letterSpacing: '2px',
            [theme.breakpoints.up('xs')]: {
                fontSize: '26px',
                marginBottom: '20px',
            },
            [theme.breakpoints.up('sm')]: {
                fontSize: '34px',
                marginBottom: '40px',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '44px',
                marginBottom: '60px',
            },
            [theme.breakpoints.up('lg')]: {
                fontSize: '48px',
                marginBottom: '80px',
            },
        },
        h3: {
            fontFamily: "'Fira Sans',Arial,sans-serif",
            fontWeight: 400,
            letterSpacing: '0px',
            lineHeight: '130%',
            [theme.breakpoints.up('xs')]: {
                fontSize: '16px',
            },
            [theme.breakpoints.up('sm')]: {
                fontSize: '18px',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '22px',
            },
            [theme.breakpoints.up('lg')]: {
                fontSize: '26px',
            },
        },
        h5: {
            fontFamily: "'Fira Sans',Arial,sans-serif",
            color: theme.palette.black[500],
        },
        menu: {
            fontSize: '16px',
            lineHeight: '120%',
            letterSpacing: '0.5px',
            fontWeight: 500,
        }
    },
})

theme = createTheme(theme, {
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: theme.typography.fontFamily,
                    fontSize: '14px',
                    fontWeight: 700,
                },
            },
            variants: [
                {
                    props: { variant: 'contained' },
                    style: {
                        fontSize: '16px',
                        lineHeight: '120%',
                        letterSpacing: '0.5px',
                        fontWeight: 500,
                        backgroundColor: theme.palette.blue[400],
                        borderRadius: 0,
                        color: 'white',
                        paddingTop: '16px',
                        paddingBottom: '16px',
                        paddingLeft: '32px',
                        paddingRight: '32px',
                        whiteSpace: 'nowrap',
                        '&:hover': {
                            backgroundColor: theme.palette.black[500],
                        }
                    }
                },
            ]
        },
    }
})

export default theme